import { createElement, useMemo, type ElementType, type HTMLAttributes } from 'react'

import { sanitizeHtml } from './safe-html'

export interface SafeHtmlProps extends HTMLAttributes<HTMLElement> {
  readonly as?: ElementType
  readonly html: string
}

export function SafeHtml({
  as: Component = 'div',
  html,
  ...htmlAttributes
}: SafeHtmlProps) {
  const sanitizedHtml = useMemo(() => sanitizeHtml(html), [html])

  return createElement(Component, {
    ...htmlAttributes,
    dangerouslySetInnerHTML: { __html: sanitizedHtml },
  })
}
